class ViewUtils {
  static isUserMaoOfProject = (projectObj, actor) => {
    return projectObj.maintenanceAgencyOwners.some(
      (mao) => mao.tid === actor.tid
    );
  };

  static isUserPoOfProject = (projectObj, actor) => {
    return projectObj.projectOwners.some((po) => po.tid === actor.tid);
  };

  static hasNonEmptyBuckets = (data) => {
    if (!data) return false;
    if (Object.keys(data).length === 0) {
      return false;
    }

    for (const key in data) {
      if (data[key]?.totalCountOfObjects > 0) {
        return true;
      }
    }

    return false;
  };
}

export default ViewUtils;
